import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import SearchIcon from '@material-ui/icons/Search';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import InfoOutlined from '@material-ui/icons/InfoOutlined';

import {FlexGridColumnGroup, FlexGridCellTemplate} from '@grapecity/wijmo.react.grid';

import {createTyohyoPdf,
  getCodeFromGeneralPurposeMap, changeDateFormat,
  getErrorCode, API_CODE, getErrorMessages, getResponseResult,
  getDataFromGeneralPurposeMap, getMaxDeleteNum} from '../../../../../../common/common.js';
import {commonOperations} from '../../../../../../reducks/common';
import {attachorderOperations} from '../../../../../../reducks/attachorder';
import MainContainer from '../../../../../organisms/MainContainer.js';
import {renderTextField, renderSelect} from '../../../../../atoms/CustomPart.js';
import {createSearchList} from '../../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../../../molecules/CustomFlexGrid.js';
import MuiTooltip from '../../../../../atoms/MuiTooltip.js';
import BackButton from '../../../../../atoms/Buttons/BackButton.js';
import DangerButton from '../../../../../atoms/Buttons/DangerButton.js';
import PositiveButton from '../../../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../../../atoms/Buttons/NegativeButton.js';
import KyogaCompanyInfo from '../../../../../molecules/KyogaCompanyInformation.js';
import * as validateRule from '../../../../../validateRule.js';
import {orderListFields} from '../../../../../../common/SFFields';
import PaperPart from '../../../../../atoms/PaperPart.js';

const styles = (theme) => ({
  button: {
    margin: '5px 10px 5px 10px',
  },
  wave: {
    fontSize: '1.2em',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  },
  fields: {
    margin: '0px 10px 15px 10px',
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
    width: '42%',
    minWidth: '100px',
  },
});

// 可否判定申込で使用する申込ステータスコード
// 作成中,可否判定受付中,強度計算中,可否判定中,可否判定済,本申込中,完結（期限切れ）,完結（取止め）,完結（申込済）
const proprietyOrderStatus = ['00', '01', '02', '03', '04', '05', '91', '92', '93'];

/**
 * 可否判定申込一覧
 * 画面ID:1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
    };
    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    if (this.gridRef && this.gridRef.current) {
      this.gridRef.current.saveScreenState('1001', 'Id');
      this.gridRef.current.setItems(null);
    }
  }

  _searchOrder = async () => {
    const {generalPurposeMap} = this.props;

    this.setState({buttonDisabled: true});

    // 検索条件
    let wkData = {};
    if (this.props.values) {
      wkData = JSON.parse(JSON.stringify(this.props.values));
    }
    wkData['OrderCategory__c'] = getCodeFromGeneralPurposeMap(generalPurposeMap, 'OrderCategory01', 2);
    wkData['RecordType.DeveloperName'] = 'ProprietyJudgeOrder';
    // 申込ステータスがなければ追加
    if (!Object.hasOwnProperty.call(wkData, 'OrderStatus__c')) {
      wkData['OrderStatus__c'] = proprietyOrderStatus;
    }

    const appSortParams = {
      CreatedDate: -1,
    };

    if (this.props.hasOwnProperty('orderList')) {
      // 申込テーブルからデータ取得
      const response = await this.props.doGetOrderTypeList(
          wkData, orderListFields, appSortParams,
          'getAttachOrderList', [], '');
      const errorCode = getErrorCode(response);
      if (errorCode != API_CODE.SUCCESS) {
        this.props.doShowMessage({
          message: {
            id: 'CE0052',
            values: ['可否判定申込', '取得'],
          },
        });
        return false;
      }

      // 件数超過エラー
      const maxKensu = getDataFromGeneralPurposeMap(
          generalPurposeMap, 'DisplayMaxKensu1', 1).ValueNum1__c;
      const dataLen = response.data.body.data ?
        response.data.body.data.length : 0;
      if (dataLen >= maxKensu) {
        this.props.doShowMessage({
          message: 'CE0015',
        });
      }

      // FlexGridに検索結果設定
      if (this.gridRef && this.gridRef.current) {
        this.gridRef.current.setItems(this.props.orderList);
      }
    }
    return true;
  }

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  searchOrder = async () => {
    try {
      const result = await this._searchOrder();
      if (!result) {
        return;
      }
      // 検索結果が0件の場合、エラーダイアログ表示
      if (!this.props.hasOwnProperty('orderList') ||
        !this.props.orderList ||
        this.props.orderList.length <= 0 ) {
        this.props.doShowMessage({
          message: 'CE0016',
        });
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 線設備新規登録ボタン押下時
   */
  doSenNext = async () => {
    try {
      const {generalPurposeMap} = this.props;
      this.props.doSetOrderId(null);
      this.props.doSetOrderModifiedCondition(null, null);
      this.props.doClearOrderInfo(); // 前回データをクリア
      this.props.doSetStbType(getCodeFromGeneralPurposeMap(generalPurposeMap, 'StbType1', 1));
      this.props.history.push({pathname: '/SenProprietyBasicInfo'});
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 点設備新規登録ボタン押下時
   */
  doTenNext = async () => {
    try {
      const {generalPurposeMap} = this.props;
      this.props.doSetOrderId(null);
      this.props.doSetOrderModifiedCondition(null, null);
      this.props.doClearOrderInfo(); // 前回データをクリア
      this.props.doSetStbType(getCodeFromGeneralPurposeMap(generalPurposeMap, 'StbType2', 1));
      this.props.history.push({pathname: '/TenProprietyBasicInfo'});
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 編集ボタン押下時
   */
  doEdit = () => {
    try {
      if (!this.gridRef ||
        !this.gridRef.current) {
        return;
      }

      const count = this.gridRef.current.selectedItemCount();
      if (count != 1) {
        this.props.doShowMessage({
          message: {
            id: 'CE0022',
          },
        });
        return;
      }

      const stbTypeSen = getCodeFromGeneralPurposeMap(this.props.generalPurposeMap, 'StbType1', 1);
      const stbTypeTen = getCodeFromGeneralPurposeMap(this.props.generalPurposeMap, 'StbType2', 1);
      const items = this.gridRef.current.selectedItem();
      this.props.doSetOrderId(items[0].dataItem.Id);
      this.props.doSetStbType(items[0].dataItem.StbType__c);
      this.props.doSetOrderModifiedCondition(
          items[0].dataItem.Id, items[0].dataItem.LastModifiedDate);
      if (items[0].dataItem.StbType__c == stbTypeSen) {
        this.props.history.push({pathname: '/SenProprietyBasicInfo'});
      }
      if (items[0].dataItem.StbType__c == stbTypeTen) {
        this.props.history.push({pathname: '/TenProprietyBasicInfo'});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 削除ボタン押下時
   */
  doDelete = async () => {
    try {
      if (!this.gridRef ||
        !this.gridRef.current) {
        return;
      }

      const count = this.gridRef.current.selectedItemCount();
      if (count == 0) {
        return;
      }

      // 作成中のみ削除可
      const orderStatusCreate = getCodeFromGeneralPurposeMap(this.props.generalPurposeMap, 'OrderStatus00', 2);
      const items = this.gridRef.current.selectedItem();
      const messages = [];
      for (let index = 0; index < items.length; index++) {
        const element = items[index];
        if (element && element.dataItem &&
            element.dataItem.OrderStatus__c != orderStatusCreate) {
          messages.push({
            id: 'CE0171',
            values: [element.dataItem.OrderNo__c],
          });
        }
      }
      if (messages.length > 0) {
        this.props.doShowMessage({message: messages});
        return;
      }

      // 選択件数が50件以下のとき、削除可能
      const maxDeleteCount = getMaxDeleteNum();
      if (count > maxDeleteCount) {
        this.props.doShowMessage({
          message: {
            id: 'CE0198',
            values: ['申込', maxDeleteCount],
          },
        });
        return;
      }

      // 選択した申込と申込に紐づく契約電柱、線設備、添付ファイルを削除
      this.props.doShowMessage({
        message: {
          id: 'CC0005',
          values: ['削除'],
        },
        action: async () => {
          const orderConditions = [];
          const contractDntConditions = [];
          const senStbConditions = [];
          for (const item of items) {
            orderConditions.push({
              Id: item.dataItem.Id,
              LastModifiedDate: item.dataItem.LastModifiedDate,
            });
          }

          const response = await this.props.doDeleteProprietyOrder(
              orderConditions, contractDntConditions, senStbConditions);
          const resResult = getResponseResult(response, ['可否判定申込', '削除']);
          if (resResult.errorCode != API_CODE.SUCCESS) {
            if (resResult.messages.filter((data) => data.id == 'CE0048').length > 0) {
              this.props.doShowMessage({
                message: resResult.messages,
                action: async () => {
                  // 排他エラーになったらデータ再読み込み
                  await this._searchOrder();
                },
              });
            } else {
              this.props.doShowMessage({
                message: resResult.messages,
              });
            }
            return;
          }
          const errorMessages = getErrorMessages(response);
          if (errorMessages.length > 0) {
            this.props.doShowMessage({message: errorMessages});
            return;
          }

          this.props.doShowMessage({
            message: {
              id: 'CI0009',
              values: ['削除'],
            },
            action: async () => {
              // 再検索
              await this._searchOrder();
            },
          });
        },
      });
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 共架内諾書ダウンロード
   */
  doDownloadFile = async () => {
    try {
      if (!this.gridRef ||
        !this.gridRef.current) {
        return;
      }

      const {userInfo, generalPurposeMap} = this.props;

      const count = this.gridRef.current.selectedItemCount();
      if (count != 1) {
        this.props.doShowMessage({
          message: {
            id: 'CE0022',
          },
        });
        return;
      }

      // 共架内諾書出力可否チェック
      // 申込ステータスが強度計算中～可否判定中までダウンロード可
      const items = this.gridRef.current.selectedItem();
      const response = await this.props.doRetrieveOrder(items[0].dataItem.Id);
      const errorCode = getErrorCode(response);
      if (errorCode != API_CODE.SUCCESS) {
        this.props.doShowMessage({
          message: {
            id: 'CE0052',
            values: ['共架内諾書', 'ダウンロード'],
          },
        });
        return;
      }
      const order = this.props.order;
      if (!order || !order.OrderNo__c) {
        this.props.doShowMessage({
          message: {
            id: 'CE0052',
            values: ['共架内諾書', 'ダウンロード'],
          },
        });
        return;
      }

      const orderStatusUnderCalc = getCodeFromGeneralPurposeMap(generalPurposeMap, 'OrderStatus02', 2);
      const orderStatusUnderP = getCodeFromGeneralPurposeMap(generalPurposeMap, 'OrderStatus03', 2);
      if (order.OrderStatus__c != orderStatusUnderCalc &&
        order.OrderStatus__c != orderStatusUnderP) {
        this.props.doShowMessage({
          message: {
            id: 'PE0176',
            values: [order.OrderNo__c],
          },
        });
        return;
      }

      const ret = await createTyohyoPdf(userInfo, 'KyogaNaidaku',
          {OrderNo__c: order.OrderNo__c}, '共架内諾書.pdf');
      if (!ret) {
        this.props.doShowMessage({
          message: {
            id: 'CE0052',
            values: ['共架内諾書', 'ダウンロード'],
          },
        });
        return;
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'check',
      filterOn: true,
      headersVisibility: 'All',
      allowDragging: 'Columns',
      counterOn: false,
      AddDeleteOn: false,
      style: {height: '300px'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
    };

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        <FlexGridColumnGroup binding="OrderNo__c" header="可否判定申込番号" dataType="String" width={160}/>
        <FlexGridColumnGroup binding="StbTypeName" header="設備種別" dataType="String" width={100}/>
        <FlexGridColumnGroup binding="KyogaTypeName" header="共架種別" dataType="String"/>
        <FlexGridColumnGroup binding="ProprietyJudgeOrderDate__c" header="可否判定\n申込年月日" dataType="Date" width={110}>
          <FlexGridCellTemplate cellType="Cell"
            template= {(context) => {
              return changeDateFormat(
                  context.item.ProprietyJudgeOrderDate__c);
            }}
          />
        </FlexGridColumnGroup>
        <FlexGridColumnGroup binding="KoziTitle__c" header="工事件名" dataType="String"/>
        <FlexGridColumnGroup header="工事場所" align="center">
          <FlexGridColumnGroup binding="KoziPlaceMainDntNo_SenroName__c" header="線路名" dataType="String"/>
          <FlexGridColumnGroup binding="Dsp_KoziPlaceMainDntNo__c" header="代表電柱番号" dataType="String"/>
          <FlexGridColumnGroup binding="KoziPlacePrefecturesName" header="都道府県" dataType="String" width={100}/>
          <FlexGridColumnGroup binding="KoziPlaceMunicipalities__c" header="市区町村" dataType="String"/>
          <FlexGridColumnGroup binding="KoziPlacePlace__c" header="場所" dataType="String"/>
        </FlexGridColumnGroup>
        <FlexGridColumnGroup binding="OrderStatusName" header="申込ステータス" dataType="String"/>
        <FlexGridColumnGroup binding="KyogasyaSendBackReason__c" header="差戻理由" dataType="String"/>
        <FlexGridColumnGroup binding="TemporarilySavedDate__c" header="一時保存日" width={110} dataType="Date">
          <FlexGridCellTemplate cellType="Cell"
            template= {(context) => {
              return changeDateFormat(context.item.TemporarilySavedDate__c);
            }}
          />
        </FlexGridColumnGroup>
      </CustomFlexGrid>
    );
  }

  render() {
    const {classes, generalPurposeMap, reset,
      handleSubmit, userInfo} = this.props;
    const footerBtn = (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="key1001CreateSen" item>
          <PositiveButton
            id="btn1001CreateSen"
            onClick={handleSubmit(this.doSenNext)}
            variant="contained"
            startIcon={<AddIcon />}
            size="large"
          >
            <span>新規申込（線設備）</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen" item>
          <MuiTooltip
            id="tl1001CreateTen"
            content='小型無線基地局，防犯カメラの申込はこちら'>
            <PositiveButton
              id="btn1001CreateTen"
              onClick={handleSubmit(this.doTenNext)}
              variant="contained"
              startIcon={<AddIcon />}
              size="large"
            >
              <span>新規申込（点設備）</span>
              <InfoOutlined fontSize="small"/>
            </PositiveButton>
          </MuiTooltip>
        </Grid>
        <Grid key="key1001EditPropriety" item>
          <PositiveButton
            id="btn1001EditPropriety"
            onClick={handleSubmit(this.doEdit)}
            variant="contained"
            startIcon={<EditIcon />}
            size="large"
            disabled={this.state.buttonDisabled}
          >
            <span>編集</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001DeletePropriety" item>
          <DangerButton
            id="btn1001DeletePropriety"
            onClick={handleSubmit(this.doDelete)}
            variant="contained"
            startIcon={<DeleteIcon />}
            size="large"
            disabled={this.state.buttonDisabled}
          >
            <span>削除</span>
          </DangerButton>
        </Grid>
        <Grid key="key1001OutputKyogaInformalConsent" item>
          <PositiveButton
            id="btn1001OutputKyogaInformalConsent"
            onClick={handleSubmit(this.doDownloadFile)}
            variant="contained"
            startIcon={<GetAppIcon/>}
            size="large"
            disabled={this.state.buttonDisabled}
          >
            <span>共架内諾書</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001Back" item>
          <BackButton props={this.props}/>
        </Grid>
      </Grid>
    );

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <span style={{whiteSpace: 'pre-line'}}>最終更新日から3か月以上超過すると作成中の件名は自動的に削除されます。ご注意ください。</span>
          <KyogaCompanyInfo companyName={userInfo.Account.Name}/>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="key1001ProprietyOrderNo" item xs={12} sm={2}>
                <Field
                  id="id1001ProprietyOrderNo"
                  name="OrderNo__c"
                  component={renderTextField}
                  className={classes.fields}
                  label="可否判定申込番号"
                  fullWidth
                  type="text"
                  required={false}
                  validate={[
                    validateRule.alphaNumericSymbol,
                    validateRule.maxLength(12),
                  ]}
                />
              </Grid>
              <Grid key="key1001StbType" item xs={12} sm={2}>
                <Field
                  id="id1001StbType"
                  name="StbType__c"
                  component={renderSelect}
                  className={classes.fields}
                  label="設備種別"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                >
                  {generalPurposeMap &&
                    createSearchList(generalPurposeMap.StbType, 'Code__c', 'Name', {Code__c: ['1', '2']})}
                </Field>
              </Grid>
              <Grid key="key1001KyogaType" item xs={12} sm={2}>
                <Field
                  id="id1001KyogaType"
                  name="KyogaType__c"
                  component={renderSelect}
                  className={classes.fields}
                  label="共架種別"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                >
                  {generalPurposeMap &&
                    createSearchList(generalPurposeMap.KyogaType,
                        'Code__c',
                        'Name',
                        {Code__c:
                          Object.hasOwnProperty.call(userInfo.Account, 'Account__r') &&
                          Object.hasOwnProperty.call(userInfo.Account.Account__r, 'KyogaType__c') ?
                          userInfo.Account.Account__r.KyogaType__c : '',
                        ValueString1__c:
                          this.props.values &&
                          Object.hasOwnProperty.call(this.props.values, 'StbType__c') ?
                          [this.props.values.StbType__c] : ['1', '2']})}
                </Field>
              </Grid>
            </Grid>
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="key1001KoziTitle" item xs={12} sm={4}>
                <Field
                  id="id1001KoziTitle"
                  name="KoziTitle__c"
                  component={renderTextField}
                  className={classes.fields}
                  label="工事件名"
                  type="text"
                  fullWidth
                  required={false}
                  validate={[
                    validateRule.maxLength(50),
                  ]}
                />
              </Grid>
              <Grid key="key1001OrderStatus" item xs={12} sm={2}>
                <Field
                  id="id1001OrderStatus"
                  name="OrderStatus__c"
                  component={renderSelect}
                  className={classes.fields}
                  label="申込ステータス"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                >
                  {generalPurposeMap &&
                       createSearchList(generalPurposeMap.OrderStatus,
                           'Code__c', 'Name', {Code__c: proprietyOrderStatus})}
                </Field>
              </Grid>
            </Grid>
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="key1001KoziPlaceMainDntNo_SenroName" item xs={12} sm={2}>
                <Field
                  id="id1001KoziPlaceMainDntNo_SenroName"
                  name="KoziPlaceMainDntNo_SenroName__c"
                  component={renderTextField}
                  className={classes.fields}
                  label="工事場所／線路名"
                  type="text"
                  fullWidth
                  required={false}
                  validate={[
                    validateRule.maxLength(30),
                  ]}
                />
              </Grid>
              <Grid key="key1001KoziPlaceMainDntNo" item xs={12} sm={2}>
                <Field
                  id="id1001KoziPlaceMainDntNo"
                  name="Dsp_KoziPlaceMainDntNo__c"
                  component={renderTextField}
                  className={classes.fields}
                  label="工事場所／代表電柱番号"
                  type="text"
                  fullWidth
                  required={false}
                  validate={[
                    validateRule.maxLength(23),
                  ]}
                />
              </Grid>
              <Grid key="key1001KoziPlacePrefectures" item xs={12} sm={2}>
                <Field
                  id="id1001KoziPlacePrefectures"
                  name="KoziPlacePrefectures__c"
                  component={renderSelect}
                  className={classes.fields}
                  label="工事場所／都道府県"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                >
                  {generalPurposeMap &&
                      createSearchList(generalPurposeMap.PrefCode)}
                </Field>
              </Grid>
              <Grid key="key1001KoziPlaceMunicipalities" item xs={12} sm={3}>
                <Field
                  id="id1001KoziPlaceMunicipalities"
                  name="KoziPlaceMunicipalities__c"
                  component={renderTextField}
                  className={classes.fields}
                  label="工事場所／市区町村"
                  type="text"
                  fullWidth
                  required={false}
                  validate={[
                    validateRule.maxLength(12),
                  ]}
                />
              </Grid>
              <Grid key="key1001KoziPlacePlace" item xs={12} sm={3}>
                <Field
                  id="id1001KoziPlacePlace"
                  name="KoziPlacePlace__c"
                  component={renderTextField}
                  className={classes.fields}
                  label="工事場所／場所"
                  type="text"
                  fullWidth
                  required={false}
                  validate={[
                    validateRule.maxLength(255),
                  ]}
                />
              </Grid>
            </Grid>
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="key1001OrderDate" item xs={12} sm={4}>
                <div style={{position: 'relative'}}>
                  <Field
                    id="id1001OrderDateFrom"
                    name="ProprietyJudgeOrderDate__c_From"
                    accessibilitylabel="ProprietyJudgeOrderDate__c_From"
                    label="可否判定申込年月日"
                    component={renderTextField}
                    className={classes.textFieldDate}
                    required={false}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    validate={[
                      validateRule.date,
                    ]}
                  />
                  <span className={classes.wave}>～</span>
                  <Field
                    id="id1001OrderDateTo"
                    name="ProprietyJudgeOrderDate__c_To"
                    accessibilitylabel="ProprietyJudgeOrderDate__c_To"
                    label={<React.Fragment />}
                    component={renderTextField}
                    className={classes.textFieldDate}
                    required={false}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    validate={[
                      validateRule.date,
                    ]}
                  />
                </div>
              </Grid>
              <Grid key="key1001Clear" item xs={12} sm>
                <NegativeButton
                  id="id1001Clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className={classes.button}
                  size="large"
                  onClick={reset}
                >
                  <span>クリア</span>
                </NegativeButton>
                <PositiveButton
                  id="id1001Search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className={clsx(classes.button)}
                  size="large"
                  onClick={handleSubmit(this.searchOrder)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="key1001List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Container),
);
